// src/services/ruleService.js
import { EDEFTER_API_URL } from '../config/edefterApi';
import AuthService from './authService';


class RuleService {
  static async list() {
    const response = await AuthService.authenticatedFetch(`${EDEFTER_API_URL}/api/aktarma-kural`);
    if (!response.ok) throw new Error('Kurallar alınamadı');
    return response.json();
  }

  static async create(payload) {
    const response = await AuthService.authenticatedFetch(`${EDEFTER_API_URL}/api/aktarma-kural`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || 'Kural oluşturulamadı');
    }
    return response.json();
  }

  static async update(id, payload) {
    const response = await AuthService.authenticatedFetch(`${EDEFTER_API_URL}/api/aktarma-kural/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || 'Kural güncellenemedi');
    }
    return response.json();
  }

  static async delete(id) {
    const response = await AuthService.authenticatedFetch(`${EDEFTER_API_URL}/api/aktarma-kural/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok && response.status !== 204) {
      const text = await response.text();
      throw new Error(text || 'Kural silinemedi');
    }
    return true;
  }

  static async setActive(id, value) {
    const response = await AuthService.authenticatedFetch(`${EDEFTER_API_URL}/api/aktarma-kural/${id}/active?value=${value}`, {
      method: 'POST',
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || 'Kural güncellenemedi');
    }
    return response.json();
  }
}

export default RuleService;
